import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";
import CustomTextField from "../../GRI300/GRI308/CustomTextField";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI413_1 = ({ hide, downloadMode = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    identificationAndImplementationProcedure: "",
    socialImpactAssessments: { percentage: "", remark: "" },
    publicDisclosure: { percentage: "", remark: "" },
    devlopmentLocalCommunity: { percentage: "", remark: "" },
    implmentationStackholder: { percentage: "", remark: "" },
    broadBased: { percentage: "", remark: "" },
    formationOfWorks: { percentage: "", remark: "" },
    grievanceProcesses: { percentage: "", remark: "" },
  });
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data =
          response.data.data.GRI400?.operationWithLocalCommunities || {};
        setFormData({
          identificationAndImplementationProcedure:
            data?.identificationAndImplementationProcedure || "",
          socialImpactAssessments: {
            percentage: data.socialImpactAssessments?.percentage || "",
            remark: data.socialImpactAssessments?.remark || "",
          },
          publicDisclosure: {
            percentage: data.publicDisclosure?.percentage || "",
            remark: data.publicDisclosure?.remark || "",
          },
          devlopmentLocalCommunity: {
            percentage: data.devlopmentLocalCommunity?.percentage || "",
            remark: data.devlopmentLocalCommunity?.remark || "",
          },
          implmentationStackholder: {
            percentage: data.implmentationStackholder?.percentage || "",
            remark: data.implmentationStackholder?.remark || "",
          },
          broadBased: {
            percentage: data.broadBased?.percentage || "",
            remark: data.broadBased?.remark || "",
          },
          formationOfWorks: {
            percentage: data.formationOfWorks?.percentage || "",
            remark: data.formationOfWorks?.remark || "",
          },
          grievanceProcesses: {
            percentage: data.grievanceProcesses?.percentage || "",
            remark: data.grievanceProcesses?.remark || "",
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Construct the correct error key
    const errorKey = `${section}.${field}`;

    // Remove error for the specific field if the value is valid
    setErrors((prev) => {
      if (value.trim()) {
        const { [errorKey]: removedError, ...rest } = prev; // Remove the specific error key
        return rest;
      }
      return prev;
    });
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // if (!formData.identificationAndImplementationProcedure) {
    //     newErrors.identificationAndImplementationProcedure = "This field is required";
    //     formIsValid = false;
    //   } else
    if (isNaN(formData.identificationAndImplementationProcedure)) {
      newErrors.identificationAndImplementationProcedure =
        "Please enter a valid numeric value";
      formIsValid = false;
    } else if (
      formData.identificationAndImplementationProcedure < 0 ||
      formData.identificationAndImplementationProcedure > 100
    ) {
      newErrors.identificationAndImplementationProcedure =
        "Please enter a value between 0 and 100";
      formIsValid = false;
    }

    // List of fields to validate
    const fieldsToValidate = [
      //   "identificationAndImplementationProcedure",
      "socialImpactAssessments",
      "publicDisclosure",
      "devlopmentLocalCommunity",
      "implmentationStackholder",
      "broadBased",
      "formationOfWorks",
      "grievanceProcesses",
    ];

    // Loop through each field and apply validation
    fieldsToValidate.forEach((field) => {
      const percentage = formData[field].percentage;
      const remark = formData[field].remark;

      // if (!percentage) {
      //   newErrors[`${field}.percentage`] = "This field is required";
      //   formIsValid = false;
      // } else
      if (isNaN(percentage)) {
        newErrors[`${field}.percentage`] = "Please enter a valid numeric value";
        formIsValid = false;
      } else if (percentage < 0 || percentage > 100) {
        newErrors[`${field}.percentage`] =
          "Please enter a value between 0 and 100";
        formIsValid = false;
      }

      // if (!remark) {
      //   newErrors[`${field}.remark`] = "This field is required";
      //   formIsValid = false;
      // }
    });

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return; // Validate form before submission

      const payload = {
        type: "GRI400",
        submitted413_1: true,
        operationWithLocalCommunities: {
          ...formData,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/413-2/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/413-2/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p
          className={styles.section_heading}
          style={{ marginBottom: hide ? "-1rem" : "0" }}
        >
          413 : Local Communities
        </p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        413-1 : Operations with local community engagement, impact assessments,
        and development programs
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}

        <SectionHeading text="a. Indicate the percentage of operations that have implemented local community engagement, impact assessments, and/or development programs, incorporating the following elements" />
        <Box
          sx={{
            display: "flex",
            width: "100%",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: "15%" }}>
            <CustomTextField
              value={formData.identificationAndImplementationProcedure}
              onChange={(e) =>
                handleInputChange(
                  "identificationAndImplementationProcedure",
                  e.target.value
                )
              }
              error={errors.identificationAndImplementationProcedure}
              placeholder={"%"}
              helperText={errors.identificationAndImplementationProcedure}
              disabled={disabled}
            />
          </Box>
        </Box>

        <Box sx={{ marginLeft: "1rem" }}>
          <SectionHeading text="i. Conducting environmental impact assessments and continuous monitoring." />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%" }}>
              <CustomTextField
                value={formData.socialImpactAssessments.percentage}
                onChange={(e) =>
                  handleNestedInputChange(
                    "socialImpactAssessments",
                    "percentage",
                    e.target.value
                  )
                }
                placeholder={"%"}
                error={!!errors["socialImpactAssessments.percentage"]}
                helperText={errors["socialImpactAssessments.percentage"]}
                disabled={disabled}
              />
            </Box>

            <Box sx={{ width: "85%" }}>
              <CustomTextField
                value={formData.socialImpactAssessments.remark}
                onChange={(e) =>
                  handleNestedInputChange(
                    "socialImpactAssessments",
                    "remark",
                    e.target.value
                  )
                }
                error={!!errors["socialImpactAssessments.remark"]}
                helperText={errors["socialImpactAssessments.remark"]}
                disabled={disabled}
              />
            </Box>
          </Box>

          <SectionHeading text="ii. Public disclosure of results stemming from environmental and social impact assessments." />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%" }}>
              <CustomTextField
                value={formData.publicDisclosure.percentage}
                onChange={(e) =>
                  handleNestedInputChange(
                    "publicDisclosure",
                    "percentage",
                    e.target.value
                  )
                }
                placeholder={"%"}
                error={!!errors["publicDisclosure.percentage"]}
                helperText={errors["publicDisclosure.percentage"]}
                disabled={disabled}
              />
            </Box>

            <Box sx={{ width: "85%" }}>
              <CustomTextField
                value={formData.publicDisclosure.remark}
                onChange={(e) =>
                  handleNestedInputChange(
                    "publicDisclosure",
                    "remark",
                    e.target.value
                  )
                }
                error={!!errors["publicDisclosure.remark"]}
                helperText={errors["publicDisclosure.remark"]}
                disabled={disabled}
              />
            </Box>
          </Box>

          <SectionHeading text="iii. Development of local community development programs aligned with the needs of local communities." />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%" }}>
              <CustomTextField
                value={formData.devlopmentLocalCommunity.percentage}
                onChange={(e) =>
                  handleNestedInputChange(
                    "devlopmentLocalCommunity",
                    "percentage",
                    e.target.value
                  )
                }
                placeholder={"%"}
                error={!!errors["devlopmentLocalCommunity.percentage"]}
                helperText={errors["devlopmentLocalCommunity.percentage"]}
                disabled={disabled}
              />
            </Box>

            <Box sx={{ width: "85%" }}>
              <CustomTextField
                value={formData.devlopmentLocalCommunity.remark}
                onChange={(e) =>
                  handleNestedInputChange(
                    "devlopmentLocalCommunity",
                    "remark",
                    e.target.value
                  )
                }
                error={!!errors["devlopmentLocalCommunity.remark"]}
                helperText={errors["devlopmentLocalCommunity.remark"]}
                disabled={disabled}
              />
            </Box>
          </Box>

          <SectionHeading text="iv. Implementation of stakeholder engagement plans formulated based on stakeholder mapping." />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%" }}>
              <CustomTextField
                value={formData.implmentationStackholder.percentage}
                onChange={(e) =>
                  handleNestedInputChange(
                    "implmentationStackholder",
                    "percentage",
                    e.target.value
                  )
                }
                placeholder={"%"}
                error={!!errors["implmentationStackholder.percentage"]}
                helperText={errors["implmentationStackholder.percentage"]}
                disabled={disabled}
              />
            </Box>

            <Box sx={{ width: "85%" }}>
              <CustomTextField
                value={formData.implmentationStackholder.remark}
                onChange={(e) =>
                  handleNestedInputChange(
                    "implmentationStackholder",
                    "remark",
                    e.target.value
                  )
                }
                error={!!errors["implmentationStackholder.remark"]}
                helperText={errors["implmentationStackholder.remark"]}
                disabled={disabled}
              />
            </Box>
          </Box>

          <SectionHeading text="v. Establishment of broad-based local community consultation committees and processes, inclusive of vulnerable groups." />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%" }}>
              <CustomTextField
                value={formData.broadBased.percentage}
                onChange={(e) =>
                  handleNestedInputChange(
                    "broadBased",
                    "percentage",
                    e.target.value
                  )
                }
                placeholder={"%"}
                error={!!errors["broadBased.percentage"]}
                helperText={errors["broadBased.percentage"]}
                disabled={disabled}
              />
            </Box>

            <Box sx={{ width: "85%" }}>
              <CustomTextField
                value={formData.broadBased.remark}
                onChange={(e) =>
                  handleNestedInputChange(
                    "broadBased",
                    "remark",
                    e.target.value
                  )
                }
                error={!!errors["broadBased.remark"]}
                helperText={errors["broadBased.remark"]}
                disabled={disabled}
              />
            </Box>
          </Box>

          <SectionHeading text="vi. Formation of works councils, occupational health and safety committees, and other worker representation bodies to address impacts." />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%" }}>
              <CustomTextField
                value={formData.formationOfWorks.percentage}
                onChange={(e) =>
                  handleNestedInputChange(
                    "formationOfWorks",
                    "percentage",
                    e.target.value
                  )
                }
                placeholder={"%"}
                error={!!errors["formationOfWorks.percentage"]}
                helperText={errors["formationOfWorks.percentage"]}
                disabled={disabled}
              />
            </Box>

            <Box sx={{ width: "85%" }}>
              <CustomTextField
                value={formData.formationOfWorks.remark}
                onChange={(e) =>
                  handleNestedInputChange(
                    "formationOfWorks",
                    "remark",
                    e.target.value
                  )
                }
                error={!!errors["formationOfWorks.remark"]}
                helperText={errors["formationOfWorks.remark"]}
                disabled={disabled}
              />
            </Box>
          </Box>

          {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
          <SectionHeading text="viii. Implementation of formal local community grievance processes." />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "15%" }}>
              <CustomTextField
                value={formData.grievanceProcesses.percentage}
                onChange={(e) =>
                  handleNestedInputChange(
                    "grievanceProcesses",
                    "percentage",
                    e.target.value
                  )
                }
                placeholder={"%"}
                error={!!errors["grievanceProcesses.percentage"]}
                helperText={errors["grievanceProcesses.percentage"]}
                disabled={disabled}
              />
            </Box>

            <Box sx={{ width: "85%" }}>
              <CustomTextField
                value={formData.grievanceProcesses.remark}
                onChange={(e) =>
                  handleNestedInputChange(
                    "grievanceProcesses",
                    "remark",
                    e.target.value
                  )
                }
                error={!!errors["grievanceProcesses.remark"]}
                helperText={errors["grievanceProcesses.remark"]}
                disabled={disabled}
              />
            </Box>
          </Box>
        </Box>

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI413_1;
